import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  SetTheDashboardClientList,
  setZoneActions,
  setRegionActions,
  setGeoLoactionStateAction,
  SettheEmployeeAttedanceResults,
  getSideBarfilesActions,
  setClientBranchActions,
  setaRoleChnage,
  setTheAttendanceDhasboardStatus,
  setTheAttendanceDateLIST,
  setAttendacenDASHTodate,
  seTheWhiteCollor,
  seTheWhiteCollar_objects,
  setTheAttendanceReportActions,
  settheStateObjects,
  setTheregionsObjects,
  setClientBranchSearchAction,
  setTheZoneObjects,
} from "../../../Redux/Slice";
import { NavLink } from "react-router-dom";
import { DateRangePicker, Stack } from "rsuite";
import { PieChart, pieArcLabelClasses } from "@mui/x-charts/PieChart";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import ApexChart from "./LinePieChart";
// import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import { Chart } from "react-google-charts";

import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import addDays from "date-fns/addDays";
import "rsuite/dist/rsuite.css";
import isAfter from "date-fns/isAfter";

import ApproveIcon from "../../../Assets/MainComponent/DashboardIcons/UDS MEDIA ASSETS-30.svg";
import DeclineIcon from "../../../Assets/MainComponent/DashboardIcons/UDS MEDIA ASSETS-31.svg";

import WeekOFF from "../../../Assets/MainComponent/DashboardIcons/Week off.svg";

import EmployeeIcons from "../../../Assets/MainComponent/DashboardIcons/UDS MEDIA ASSETS-33.svg";

import { saveAs } from "file-saver";
import * as XLSX from "sheetjs-style";
import { differenceInDays } from "date-fns";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getLoaderAction } from "../../../Redux/Loader";
import useDebouncedEffect from 'use-debounced-effect';

const AttendanceDash = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const Navigate = useNavigate();
  const state = useSelector((state) => state);
  const [nameList4, setOptions4] = useState([]);
  const dispatch = useDispatch();
  const [Client, setClients] = useState();
  const [clientname, setClientName] = useState("ALL");
  const [count, setCount] = useState(0);

  const [selectedValues, SetSelectValue] = useState([]);
  ///----Filter-----------------------
  ///--filter----------------
  let [nameList, setOptions] = useState([]);
  const [nameList2, setOptions2] = useState([]);
  const [REgion, setRegion] = useState([]);
  const [multiselect1, setMuliselect1] = useState([
    // { value: "", label: "All" },
    // state.ClientBranchIDs.RegionName,
    state.EmployeeVerificationsNeed.RegionObjects,
  ]);
  const [multiselect3, setMuliselect3] = useState([
    // { value: "", label: "All" },
    // state.ClientBranchIDs.ZoneName,
    state.EmployeeVerificationsNeed.ZoneObjects,
  ]);
  const [nameList5, setOptions5] = useState([]);
  const [Zone, setZone] = useState([]);
  const [datas, setData] = useState({
    //   zone: state.ClientBranchIDs.ZoneName.value,
    // state: state.ClientBranchIDs.StateName.value,
    // region: state.ClientBranchIDs.RegionName.value,

    zone: state.EmployeeVerificationsNeed.ZoneObjects.value,
    state: state.EmployeeVerificationsNeed.StateObjects.value,
    region: state.EmployeeVerificationsNeed.RegionObjects.value,
  });
  const [multiselect, setMuliselect] = useState([
    //  { value: "", label: "All" }
    // state.ClientBranchIDs.StateName,
    state.EmployeeVerificationsNeed.StateObjects,
  ]);
  const [search, setSearch] = useState("");

  const [Name, setName] = useState({
    // StateName: multiselect[0].label,
    // ZoneName: multiselect3[0].label,

    StateName: "All",
    ZoneName: "All",
  });
  // console.log(multiselect3, "multiselect3", Name, multiselect);
  ///-----attendance----list
  const [workingEmp, setWrkEmp] = useState(0);
  const [attendanceTotalWork, setAttendanceWrok] = useState(0);
  const [attendancePresent, setAttendacePresent] = useState(0);
  const [attendanceAbsent, setAttendanceAbsent] = useState(0);
  ///---to find the zero in the bar chart
  const [AttendanceZeor, setAttendanceZero] = useState(false);

  const UserObjectData = useSelector((state) => state.users.UserData);

  const initialStateSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
  };
  const [SearchedVal, setSearched] = useState(initialStateSearch);
  const initialDebouanceSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
    Clientsearch:""
  };

  const [SearchDebounance, setSearchDebounance] = useState(initialDebouanceSearch);

  ///---filter for white collar--------
  const [EmpRoles, setEmplyeRole] = useState([
    {
      value: "",
      label: "ALL",
    },
    {
      value: "1",
      label: "UDS",
    },
    {
      value: "2",
      label: "CLIENT",
    },
  ]);
  const [EMpROleSelected, setEmpRoleSele] = useState(EmpRoles[0]);
  const [filterForWhite, setFilters] = useState({ white_collar: "" });
  // console.log(EmpRoles , "EmpRoles", EMpROleSelected.value);
  // console.log(EMpROleSelected, "EMpROleSelected", EMpROleSelected.value);

  const getCurrentMonthStartAndEndDate = () => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth();

    // Set the start date of the current month to the 1st day of the current month
    const firstDateOfMonth = new Date(currentYear, currentMonth, 1);

    // Set the end date of the current month to the last day of the current month
    const lastDateOfMonth = new Date(currentYear, currentMonth + 1, 0);

    const startDatemon = `${currentYear}-${String(currentMonth + 1).padStart(
      2,
      "0"
    )}-${String(currentDate.getDate()).padStart(2, "0")}`;

    // const endDatemon = `${currentYear}-${String(currentMonth + 1).padStart(
    //   2,
    //   "0"
    // )}-${String(lastDateOfMonth.getDate()).padStart(2, "0")}`;
    const endDatemon = `${currentYear}-${String(currentMonth + 1).padStart(
      2,
      "0"
    )}-${String(currentDate.getDate()).padStart(2, "0")}`;
    return {
      startDatemon,
      endDatemon,
    };
  };

  var { startDatemon, endDatemon } = getCurrentMonthStartAndEndDate();

  const [datestae, setdatest] = useState(false);
  const RoleBased = useSelector((state) => state.SideBarFiles.Role);

  const [datefilter, setdatefilter] = useState({
    from_date: startDatemon,
    to_date: endDatemon,
    range: true,
  });

  const [countforAttendances, setcountforAttendancedetails] = useState(0);
  const [countforAbsent, setcountforAbsentdetails] = useState(0);
  const [Totalworkers, setTotalWorkers] = useState(0);
  //// testing
  const data = [
    {
      value: countforAbsent,
      label: "Present Employees",
    },
    {
      value: countforAttendances,
      label: "Absent Employees",
    },
  ];

  const size = {
    width: 600,
    height: 300,
  };

  const capitalizeFirstLetter = (Letter) => {
    return Letter.charAt(0).toUpperCase() + Letter.slice(1);
  };

  const startDate = new Date();
  const endDate = new Date();

  const [selectedDates, setSelectedDates] = useState([startDate, endDate]);

  const [percentage, setPercentage] = useState({
    countforAbsent: 3,
    countforAttendances: 2,
    workingEmp: 0,
    // EmployeeCounts: 3,
    WeekOFF: 3,
  });

  const [PresentEmp, setPresentEm] = useState({
    workingEmp: 0,
    PresentEMp: 2,
    AbsentEmp: 3,
    WeekOff: 0,
    EmployeeCounts: 0,
  });

  var today = new Date();
  var priorDate = new Date(new Date().setDate(today.getDate() - 30));
  // var it = convert(today);
  // var gt = convert(priorDate);
  // // console.log(it, gt);
  // const [range, setrange] = useState([it, it]);

  var it = convert(today);
  var gt = convert(today);

  // console.log(it, gt);
  // state.EmployeeVerificationsNeed.FROMDATE,
  // state.EmployeeVerificationsNeed.TODATE,

  var st = convert(state.EmployeeVerificationsNeed.AttendanceFROMDATE);
  var et = convert(state.EmployeeVerificationsNeed.AttendanceTODATE);





  const [range, setrange] = useState(
    state.EmployeeVerificationsNeed.AttendanceFROMDATE == ""
      ? // [it, gt]
        []
      : [st, et]
  );


  useEffect(()=>{
    if (range.length > 0 && !range.includes("NaN-aN-aN")) {
      dispatch(setTheAttendanceDateLIST(range[0]));
    dispatch(setAttendacenDASHTodate(range[1]));
    }
  },[range])


  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  const formattedDates =
    selectedDates != null &&
    selectedDates.map((date) => {
      const isoString = date.toISOString();
      return isoString.substring(0, 10);
    });
  const HandleEMprole = (e) => {
    if (e != null) {
      setEmpRoleSele(e);

      if (e.value == 1) {
        dispatch(setaRoleChnage(1));
        setFilters({
          ...filterForWhite,
          white_collar: true,
        });
        dispatch(SetTheDashboardClientList({ value: "", label: "ALL" }));
        setClients("");
      } else if (e.value == 2) {
        dispatch(setaRoleChnage(2)); ///Role based dispatch for the white_collar
        setFilters({
          ...filterForWhite,
          white_collar: false,
        });
      } else if (e.value == "") {
        setFilters({
          ...filterForWhite,
          white_collar: "",
        });
      }
    }
  };

  ///---Branches------------------------------
  useEffect(() => {
    if (datas.state != "") {
      const payload = {
        search: search,
        page_size: "",
        page: 1,
        data: datas,
      };
      dispatch(setClientBranchSearchAction(payload));

      //  console.log(state.ClientBranch.ClientBranchess, "asdasd");
    }
  }, [search, datas]);

  // useEffect(() => {
  //   if (state.users.UserData.data != undefined) {
  //     if (UserObjectData.session) {
  //       const udsroleSelectedstate = [];
  //       const zoneselact = [];
  //       const regionsSelect = [];

  //       if (UserObjectData.data.state_id.length > 0) {
  //         UserObjectData.data.state_id.map((item, index) => {
  //           // console.log(item, "287398273");
  //           if (index == 0) {
  //             udsroleSelectedstate.push({
  //               value: item.id,
  //               label: item.state_name,
  //             });
  //           }
  //         });
  //       }

  //       if (UserObjectData.data.state_id.length == 0) {
  //         udsroleSelectedstate.push({ value: "", label: "All" });
  //       }

  //       if (UserObjectData.data.zone_id.length > 0) {
  //         UserObjectData.data.zone_id.map((item, index) => {
  //           if (index == 0) {
  //             zoneselact.push({
  //               value: item.id,
  //               label: item.zone_name,
  //             });
  //           }
  //         });
  //       }

  //       if (UserObjectData.data.region_id.length > 0) {
  //         UserObjectData.data.region_id.map((item, index) => {
  //           if (index == 0) {
  //             regionsSelect.push({
  //               value: item.id,
  //               label: item.region_name,
  //             });
  //           }
  //         });
  //       }
  //       if (UserObjectData.data.zone_id.length == 0) {
  //         zoneselact.push({ value: "", label: "All" });
  //       }
  //       if (UserObjectData.data.region_id.length == 0) {
  //         regionsSelect.push({ value: "", label: "All" });
  //       }

  //       setData({
  //         ...datas,
  //         state: udsroleSelectedstate[0].value,
  //         zone: zoneselact[0].value,
  //         region: regionsSelect[0].value,
  //       });

  //       setMuliselect1(regionsSelect);
  //       setMuliselect(udsroleSelectedstate);

  //       setMuliselect3(zoneselact);

  //       setName({
  //         ...Name,
  //         StateName: udsroleSelectedstate[0].label,
  //         ZoneName: zoneselact[0].label,
  //       });
  //     }
  //   }
  // }, [UserObjectData]);
  // console.log(state.EmployeeDashBoardAttedances.AttedanceDatas.employee_count , "employee_count");
  useEffect(() => {
    console.log(range, range[0] == range[1], "1273012730range");

    if (state.EmployeeDashBoardAttedances.AttedanceDatas && range.length > 0) {
      const Options = {
        countforAbsent:
          state.EmployeeDashBoardAttedances.AttedanceDatas
            .absent_employee_percentage,
        countforAttendances:
          state.EmployeeDashBoardAttedances.AttedanceDatas
            .present_employee_percentage,
        workingEmp:
          state.EmployeeDashBoardAttedances.AttedanceDatas
            .working_employee_percentage,
        // EmployeeCounts:
        //   state.EmployeeDashBoardAttedances.AttedanceDatas.employee_count,
        WeekOFF:
          state.EmployeeDashBoardAttedances.AttedanceDatas
            .weekoff_employee_percentage,



        //   countforAbsent:
        //   state.EmployeeDashBoardAttedances.AttedanceDatas
        //     .absent_employee,
        // countforAttendances:
        //   state.EmployeeDashBoardAttedances.AttedanceDatas
        //     .present_employee,
        // workingEmp:
        //   state.EmployeeDashBoardAttedances.AttedanceDatas
        //     .working_employee,
        // EmployeeCounts:
        //   state.EmployeeDashBoardAttedances.AttedanceDatas.employee_count,
        // WeekOFF:
        //   state.EmployeeDashBoardAttedances.AttedanceDatas
        //     .weekoff_employee,
      };
      setPercentage(Options);
      const Options1 = {
        AbsentEmp:
          state.EmployeeDashBoardAttedances.AttedanceDatas.absent_employee,
        PresentEMp:
          state.EmployeeDashBoardAttedances.AttedanceDatas.present_employee,
        workingEmp:
          state.EmployeeDashBoardAttedances.AttedanceDatas.working_employee,
        EmployeeCounts:
          // state.EmployeeDashBoardAttedances.AttedanceDatas.total_user,
          state.EmployeeDashBoardAttedances.AttedanceDatas.employee_count,
        WeekOff:
          state.EmployeeDashBoardAttedances.AttedanceDatas.weekoff_employee,
      };
      setPresentEm(Options1);
    } else if (range.length == 0) {
      const Options = {
        countforAbsent: 0,
        countforAttendances: 0,
        workingEmp: 0,
        // EmployeeCounts: 0,
        WeekOFF: 0,
      };
      setPercentage(Options);

      const Options1 = {
        AbsentEmp: 0,
        PresentEMp: 0,
        workingEmp: 0,
        EmployeeCounts:
          // state.EmployeeDashBoardAttedances.AttedanceDatas.total_user,
          0,
        WeekOff: 0,
      };
      setPresentEm(Options1);
    }
  }, [state.EmployeeDashBoardAttedances.AttedanceDatas, range, Client, datas]);
console.log(percentage ,"09130percentage",PresentEmp);

  // const getCurrentMonthStartAndEndDate = () => {
  //   const currentDate = new Date();
  //   const currentYear = currentDate.getFullYear();
  //   const currentMonth = currentDate.getMonth() + 1;
  //   const firstDateOfMonth = new Date(currentYear, currentMonth - 1, 1);
  //   const lastDateOfMonth = new Date(currentYear, currentMonth, 0);

  //   const startDatemon = `${currentYear}-${String(currentMonth).padStart(
  //     2,
  //     "0"
  //   )}-${String(firstDateOfMonth.getDate()).padStart(2, "0")}`;
  //   const endDatemon = `${currentYear}-${String(currentMonth).padStart(
  //     2,
  //     "0"
  //   )}-${String(lastDateOfMonth.getDate()).padStart(2, "0")}`;

  //   return {
  //     startDatemon,
  //     endDatemon,
  //   };
  // };

  // var { startDatemon, endDatemon } = getCurrentMonthStartAndEndDate();
  //---Download---the ----present---employee------sheets
  // useEffect(() => {
  //   console.log(filterForWhite.white_collar , "white_collar");

  //    if(filterForWhite.white_collar !="" && !filterForWhite.white_collar || filterForWhite.white_collar){
  //   const payload = {
  //     search: "",
  //     page_size: "",
  //     page: 1,
  //     from_date: range[0],
  //     to_date: range[1],
  //     range: true,
  //     state: datas.state,
  //     region: datas.region,
  //     zone: datas.zone,
  //     // client: Client,
  //     client: Client,

  //     return_type: "all_employee",
  //     // white_collar: filterForWhite.white_collar,
  //     white_collar: filterForWhite.white_collar,
  //   };
  //   dispatch(setTheAttendanceReportActions(payload));
  // }

  // }, [filterForWhite, range, Client, datas]);

  // range, datas, Client, filterForWhite
  //  console.log(state.AttendanceREPORTDataCall.AttendanceReportData , "AttendanceReportData");
  // console.log(Client , "Client");
  ////-- dispatch --- the ----- client list
  useEffect(() => {
    dispatch(SetTheDashboardClientList({ value: "", label: "ALL" }));
  }, []);

  const HandleClientBranches = (selectedVal) => {
    //  console.log(selectedVal, "selectedvalue", counts);
    dispatch(SetTheDashboardClientList(selectedVal));
    SetSelectValue(selectedVal);
    if (selectedVal != null) {
      //  console.log("in Search");
      setClients(selectedVal.value);
      SetSelectValue(selectedVal);
      setClientName(selectedVal.label);
    } else {
      //   setempVer(0);
      //   setCount(0);
      //   setPendignEmp(0);
      //   setDeclineEmp(0);
      setClients("");

      dispatch(SetTheDashboardClientList({ value: "", label: "ALL" }));
    }
  };
  const HandleInputBranch = (e) => {
    setSearchDebounance({
      ...SearchDebounance,
      Clientsearch:e
    })
  };
  useEffect(() => {
    if (state.BranchSearchpart.BranchSearch != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });
            state.BranchSearchpart.BranchSearch.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.client_name,
        });
      });
      setOptions4(objectArray);
    }
  }, [state.BranchSearchpart.BranchSearch, search]);
  useEffect(() => {
    if (range.length > 0 && !range.includes("NaN-aN-aN")) {
      const payloaddt = {
        state: datas.state,
        region: datas.region,
        zone: datas.zone,
        from_date: range[0],
        to_date: range[1],
        range: datefilter.range,
        client: Client,
        white_collar: filterForWhite.white_collar,
      };

      setTimeout(() => {
        dispatch(SettheEmployeeAttedanceResults(payloaddt));
      }, 250);
    }
  }, [datas, Client, datefilter, range, filterForWhite]);


  useEffect(() => {
    if (range.includes("NaN-aN-aN")) {
      setrange([]);
    } else if (range.length === 0) {
      // Do something if the list is already empty
      console.log("The list is already empty");
    }
  }, []);

  ////--present details----
  useEffect(() => {
    const intervalId1 = setInterval(() => {
      if (
        state.EmployeeDashBoardAttedances.AttedanceDatas.present_employee != 0
      ) {
        setAttendacePresent((prevCount) => {
          if (
            prevCount <
            state.EmployeeDashBoardAttedances.AttedanceDatas.present_employee
          ) {
            return prevCount + 1;
          } else {
            clearInterval(intervalId1);
            return prevCount;
          }
        });
      }
    }, 100);
    return () => clearInterval(intervalId1);
  }, [state.EmployeeDashBoardAttedances.AttedanceDatas.present_employee]);

  ////--Absent  details----
  useEffect(() => {
    const intervalId1 = setInterval(() => {
      if (
        state.EmployeeDashBoardAttedances.AttedanceDatas.absent_employee != 0
      ) {
        setAttendanceAbsent((prevCount) => {
          if (
            prevCount <
            state.EmployeeDashBoardAttedances.AttedanceDatas.absent_employee
          ) {
            return prevCount + 1;
          } else {
            clearInterval(intervalId1);
            return prevCount;
          }
        });
      }
    }, 100);
    return () => clearInterval(intervalId1);
  }, [state.EmployeeDashBoardAttedances.AttedanceDatas.absent_employee]);

  ///----workers----details--
  useEffect(() => {
    const intervalId1 = setInterval(() => {
      if (state.EmployeeDashBoardAttedances.AttedanceDatas.total_user != 0) {
        setTotalWorkers((prevCount) => {
          if (
            prevCount <
            state.EmployeeDashBoardAttedances.AttedanceDatas.total_user
          ) {
            return prevCount + 1;
          } else {
            clearInterval(intervalId1);
            return prevCount;
          }
        });
      }
    }, 100);
    return () => clearInterval(intervalId1);
  }, [state.EmployeeDashBoardAttedances.AttedanceDatas.total_user]);

  useEffect(() => {
    if (state.EmployeeDashBoardAttedances.AttedanceDatas != null) {
      if (
        state.EmployeeDashBoardAttedances.AttedanceDatas
          .present_employee_percentage == 0 &&
        countforAttendances == 0
      ) {
        setAttendanceZero(true);
      } else if (
        state.EmployeeDashBoardAttedances.AttedanceDatas
          .present_employee_percentage != 0 ||
        state.EmployeeDashBoardAttedances.AttedanceDatas
          .absent_employee_percentage != 0
      ) {
        setAttendanceZero(false);
      }
    }
  }, [state.EmployeeDashBoardAttedances.AttedanceDatas, range]);

  useEffect(() => {
    if (
      Client != undefined ||
      datestae ||
      (datas.state == "" && datas.region == "" && datas.zone == "")
    ) {
      setcountforAbsentdetails(0);
      setcountforAttendancedetails(0);

      ///------counts--------------
      setAttendanceWrok(0);
      setAttendanceAbsent(0);
      setAttendacePresent(0);
    }
  }, [datas, Client, datestae]);

  useEffect(() => {
    if (datestae) {
      setdatefilter({
        ...datefilter,
        from_date: formattedDates[0],
        to_date: formattedDates[1],
        range: true,
      });
    }
  }, [selectedDates]);

  //----Handle----Date=-----Changes---
  const handlechangedate = (value) => {
    console.log(value, "vlues");
    // if (value != null) {
    //   setSelectedDates(value);
    //   setdatest(true);
    //   value.forEach((newValue) => {
    //     const tzoffset = new Date().getTimezoneOffset() * 60000;
    //     const localISOTime = new Date(newValue - tzoffset)
    //       .toISOString()
    //       .slice(0, -1);
    //   });
    // }

    if (value != null) {
      setrange((oldArray) => [...oldArray, value.slice(0, 10)]);
      // setSelectedDates(value);
      setdatest(true);
      // value.forEach((newValue) => {
      //   const tzoffset = new Date().getTimezoneOffset() * 60000;
      //   const localISOTime = new Date(newValue - tzoffset)
      //     .toISOString()
      //     .slice(0, -1);
      //   // handle the start and end dates here
      // });

      setdatefilter({
        ...datefilter,
        from_date: range[0],
        to_date: range[1],
        range: true,
      });

      // console.log(datefilter, "datefilter");
    }
  };

  ///--------------State-----------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.stateSearch,
      page_size: "",
      page: 1,
    };
    dispatch(setGeoLoactionStateAction(payloads));
  }, [SearchedVal.stateSearch]);

  //--------------_Zone---------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.zoneSearch,
      page_size: 20,
      page: 1,
      counts: 1,
      region_id: datas.region,
    };
    dispatch(setZoneActions(payloads));
    setZone(state.ZonePart.Zone);
  }, [datas.region, SearchedVal.zoneSearch]);

  //-----Region---------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.regionSearch,
      page_size: 20,
      page: 1,
      counts: 1, //-----only we ----get----the----selected regions , the--id only
      state: datas.state,
    };
    dispatch(setRegionActions(payloads));
    //console.log(State.regioncall.RegionDat, "states", State.regioncall.Total_Count);
    setRegion(state.regioncall.RegionDat);
  }, [datas.state, SearchedVal.regionSearch]);

  useEffect(() => {
    const Datas = [];

    if (state.GeoState.State != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });
      state.GeoState.State.forEach((element) => {
        objectArray.push({ value: element.id, label: element.state_name.toUpperCase() });
      });

      setOptions(objectArray);
    }
  }, [state.GeoState.State, SearchedVal.stateSearch]);
  ///  ///----------------------REgion-----------
  useEffect(() => {
    const Datas = [];

    setRegion(state.regioncall.RegionDat);
    if (state.regioncall.RegionDat != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });
      state.regioncall.RegionDat.forEach((element) => {
        objectArray.push({ value: element.id, label: element.region_name.toUpperCase() });
      });

      setOptions2(objectArray);
    }
  }, [state.regioncall.RegionDat, SearchedVal.regionSearch]);
  //----Region----------------
  const handelRegionSlect = (selectedVal) => {
    if (selectedVal != null) {
      setMuliselect1(selectedVal);
      setMuliselect3([]);
      setData({
        ...datas,
        region: selectedVal.value,
      });
    }
    if (selectedVal == null) {
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });
      setData({
        ...datas,
        region: "",
        zone: "",
      });
    }
  };
  //----------------Zone
  const handleZone = (selectedVal) => {
    //console.log(selectedVal ,"selected Values");
    if (selectedVal != null) {
      setMuliselect3(selectedVal);
      setData({
        ...datas,
        zone: selectedVal.value,
      });

      setName({
        ...Name,
        ZoneName: selectedVal.label,
        StateName: Name.StateName,
      });
    }

    if (selectedVal == null) {
      setMuliselect3({ value: "", label: "ALL" });
      setName({
        ...Name,
        ZoneName: "",
        StateName: Name.StateName,
      });
      setData({
        ...datas,
        zone: "",
      });
    }
  };
  const handleSelectChange = (selectedVal) => {
    if (selectedVal != null) {
      setMuliselect(selectedVal);
      setMuliselect3({value:"",label:"ALL"});
      setMuliselect1({value:"",label:"ALL"});

      setData({
        ...datas,
        state: selectedVal.value,
        region: "",
        zone: "",
      });

      setName({
        ...Name,
        StateName: selectedVal.label,
        ZoneName: "",
      });
    }

    if (selectedVal == null) {
      setMuliselect({ value: "", label: "ALL" });
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });
      setData({
        ...datas,
        state: "",
        zone: "",
        region: "",
      });

      setName({
        ...Name,
        StateName: "",
        ZoneName: "",
      });
    }
  };
  ///-------------Zone--------------
  useEffect(() => {
    const Datas = [];

    setZone(state.ZonePart.Zone);
    if (state.ZonePart.Zone != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });
      state.ZonePart.Zone.forEach((element) => {
        objectArray.push({ value: element.id, label: element.zone_name.toUpperCase() });
      });
      setOptions5(objectArray);
    }
  }, [state.ZonePart.Zone, SearchedVal.zoneSearch]);
  useDebouncedEffect(
    () => {
      if (setSearchDebounance) {
        setSearched({
          ...SearchedVal,
          stateSearch: SearchDebounance.stateSearch,
          regionSearch: SearchDebounance.regionSearch,
          zoneSearch: SearchDebounance.zoneSearch,
        });
        setSearch(SearchDebounance.Clientsearch);

      }
    },
    500,
    [SearchDebounance]
  );
///-----State----Input Changes
const handleInputChange = (Val) => {
  setSearchDebounance({
    ...SearchDebounance,
    stateSearch: Val,

  });

};

///---Region-----------------
const handleInputRegion = (Val) => {
  setSearchDebounance({
    ...SearchDebounance,
    regionSearch: Val,
  });
};
///----Zone---Name
const handleInputZone = (Val) => {
  setSearchDebounance({
    ...SearchDebounance,
    zoneSearch:Val,
  });
};

  const Attendancedata = [
    ["Employees Attendance", "count"],
    // ["Present Employees", percentage.countforAttendances],
    // ["Absent Employees", percentage.countforAbsent],
    // ["Working Employees", percentage.workingEmp],
    ["Present Employees", percentage.countforAttendances || 0],
    ["Absent Employees", percentage.countforAbsent || 0],
    ["Working Employees", percentage.workingEmp || 0],
  


  ];



   const options_attendances = {
    title: "Attendance Details",

    pieHole: 0.5,
    is3D: false,
    slices: {
      0: { color: "#1FDC0F" },
      1: { color: "#FF0000" },
      // 2: { color: "#11734B" },
    },
    sliceVisibilityThreshold: 0, // Ensure all slices are visible

    titleTextStyle: {
      fontSize: 14, // Title font size
    },
    legend: {
      textStyle: {
        fontSize: 13, // Legend font size
      },
    },
    tooltip: {
      textStyle: {
        fontSize: 13, // Tooltip font size
      },
    },
    chartArea: {
      // width: '90%', // Adjust chart area to fit better
      // height: '70%',
      width: "90%", // Adjust chart area to fit better
      height: "70%",
      top: 50, // Adjust top margin to create space for the title
    },
  };

  const predefinedBottomRanges = [
    {
      label: "Today",
      value: [new Date(), new Date()],
      placement: "left",
    },
    {
      label: "Yesterday",
      value: [addDays(new Date(), -1), addDays(new Date(), -1)],
      placement: "left",
    },
    {
      label: "This week",
      value: [startOfWeek(new Date()), endOfWeek(new Date())],
      placement: "left",
    },
    {
      label: "Last week",
      value: (value, index) => {
        const [start = new Date()] = value[index] || [];
        return [
          addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
          addDays(endOfWeek(start, { weekStartsOn: 0 }), -7),
        ];
      },
      placement: "left",
    },
    {
      label: "Last 30 days",
      value: [subDays(new Date(), 29), new Date()],
      placement: "left",
    },
  ];

  const cleaningrange = () => {
    //setrange([gt,it]);
  };

  // const HandleClick = (e, value) => {
  //   const data1 = [
  //     // ["Employee Attendance", "Percentage"],
  //     // ["Present Employees", percentage.countforAttendances],
  //     // ["Absent Employees", percentage.countforAbsent],
  //     // ["Working Employees", percentage.workingEmp],
  //     ["Branch Name", clientname, "From Date", range[0], "To Date", range[1]],
  //     ["Sno", "Type", "Percentage"],

  //     ["1", "Present Employees", percentage.countforAttendances],
  //     ["2", "Absent Employees", percentage.countforAbsent],
  //     ["3", "Week Off", percentage.WeekOFF],
  //     ["4", "Working Employees", percentage.workingEmp],
  //     ["5", "Employees", percentage.EmployeeCounts],

  //     [

  //       "Total Employees",
  //       Math.round(percentage.countforAttendances +
  //         percentage.countforAbsent +
  //         percentage.WeekOFF +
  //         percentage.workingEmp +
  //         percentage.EmployeeCounts),
  //     ],

  //   ];

  //   // Create a new workbook and add a worksheet
  //   const ws = XLSX.utils.aoa_to_sheet(data1);

  //   const wb = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

  //   // Generate Excel file and trigger a download
  //   const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  //   const dataBlob = new Blob([excelBuffer], {
  //     type: "application/octet-stream",
  //   });
  //   saveAs(dataBlob, "AttendanceData.xlsx");
  // };

  const HandleClick = (e, value) => {
    const attendanceData = state.AttendanceREPORTDataCall.AttendanceReportData;

    // console.log(attendanceData, "attendanceData");

    // Ensure attendanceData is an array and has elements
    if (!Array.isArray(attendanceData) || attendanceData.length === 0) {
      console.error("Invalid or empty attendance data");
      return;
    }

    // Create the header for the Excel sheet
    const data1 = [
      ["Branch Name", clientname, "Date", range[0]],

      [" ", " ", "  "],

      ["  ", " ", "  "],

      ["Sno", "TYPE", "Percentage"],
    ];

    data1.push(
      ["1", "Present Employees", percentage.countforAttendances],
      ["2", "Absent Employees", percentage.countforAbsent],
      ["3", "Week Off", percentage.WeekOFF],
      ["4", "Working Employees", percentage.workingEmp],
      ["5", "Employees", percentage.EmployeeCounts],

      [" ", " ", "  "],

      ["  ", " ", "  "],

      ["  ", "  ", "  "],

      ["  ", " ", " "],

      // EMpROleSelected.value == "2" ? "Zone Name" : null,
      // EMpROleSelected.value == "2" ? Name.ZoneName : "--",
      [
        "Sno",
        EMpROleSelected.value == "1" ? "State Name" : null,
        "Name",
        "Punch In",
        "Punch Out",
      ]
    );
    let checkInTimeCount = 0;

    // Iterate through the attendanceData to add the employee details
    attendanceData.forEach((record, index) => {
      const {
        user_id,
        present,
        leave,
        date,
        weekoff,
        working,
        check_in_time,
        check_out_time,
        zone_id,
      } = record;
      const name = user_id ? user_id.first_name : "Unknown";
      // console.log(record.user_id.zone_id , "record");
      const dateString = check_in_time;
      const dateObject = new Date(dateString);
      const hours = dateObject.getHours();
      const minutes = dateObject.getMinutes();
      const seconds = dateObject.getSeconds();
      const amOrPm = hours >= 12 ? "PM" : "AM";
      const twelveHourFormat = hours % 12 || 12;
      if (check_in_time) {
        checkInTimeCount++;
      }

      const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

      const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

      const dateStringCheckout = check_out_time;
      const dateCheckoutObject = new Date(dateStringCheckout);
      const hourscheckout = dateCheckoutObject.getHours();
      const minuteschecko = dateCheckoutObject.getMinutes();
      const secondsCheckO = dateCheckoutObject.getSeconds();
      const amOrPmChOut = hourscheckout >= 12 ? "PM" : "AM";
      const twelveHourFormatOut = hourscheckout % 12 || 12;

      const formattedMinutesOut =
        minuteschecko < 10 ? `0${minuteschecko}` : minuteschecko;

      const formattedTimeOut = `${twelveHourFormatOut}:${formattedMinutesOut} ${amOrPmChOut}`;

      let type = "Unknown";
      const checkoutTime =
        formattedTimeOut && check_out_time ? formattedTimeOut : "--";
      const checkInTime = formattedTime && check_in_time ? formattedTime : "--";
      // console.log(checkInTime, "checkInTime");
      const check_in = check_in_time
        ? check_in_time + " " + check_in_time
        : "--";
      const check_out = check_out_time
        ? check_out_time + "" + check_out_time
        : "--";
      var ZoneName = [];
      var StateName = [];

      var Names = [];
      if (
        record.user_id.state_id != undefined &&
        record.user_id.state_id != null
      ) {
        record.user_id.state_id.forEach((item, index) => {
          console.log(
            index,
            item,
            "item.zone_name",
            item.state_name,
            Name.StateName
          );
          // item.state_name == Name.StateName &&
          console.log(multiselect[0]?.label, item.state_name, "multiselect");
          if (
            multiselect[0]?.label != undefined
              ? multiselect[0]?.label == "All"
              : multiselect.label == "All"
          ) {
            if (index == 0) {
              StateName.push(item.state_name);
            }
          } else {
            if (index == 0) {
              StateName.push(
                multiselect[0]?.label != undefined
                  ? multiselect[0]?.label
                  : multiselect.label
              );
            }
          }
          if (item.state_name == Name.StateName) {
            Names.push(user_id.first_name ? user_id.first_name : "Unknown");
          }
        });
      }

      // console.log(Names, "Names", user_id.first_name);
      const dateFile = date ? date : "---";

      data1.push([
        index + 1, // Serial number
        EMpROleSelected.value == "1" ? StateName : null,
        name,
        // dateFile,

        checkInTime,
        checkoutTime,
        // Assuming percentage is calculated and added to the data
      ]);
    });

    data1.push(
      [" ", " ", "  "],
      ["  ", " ", "  "],
      ["  ", "  ", "  "],
      ["  ", " ", " "],
      ["Total-Punched Counter ", checkInTimeCount]
    );
    // Add a summary row
    const ws = XLSX.utils.aoa_to_sheet(data1);

    // Apply left alignment to all cells
    Object.keys(ws).forEach((key) => {
      if (key[0] !== "!") {
        // Exclude special keys such as "!ref"
        ws[key].s = {
          alignment: {
            horizontal: "left",
          },
        };
      }
    });

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    // Generate Excel file and trigger a download
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const dataBlob = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });
    saveAs(dataBlob, `${range[0] + "-" + range[1]}Attendance.xlsx`);
  };

  const HandleClickSecond = (e, value) => {
    const attendanceData = state.AttendanceREPORTDataCall.AttendanceReportData;

    console.log(attendanceData, "attendanceData");

    // Ensure attendanceData is an array and has elements
    if (!Array.isArray(attendanceData) || attendanceData.length === 0) {
      console.error("Invalid or empty attendance data");
      return;
    }

    // Create the header for the Excel sheet
    const data1 = [
      ["Branch Name", clientname, "Date", range[0]],

      [" ", " ", "  "],

      ["  ", " ", "  "],

      ["Sno", "TYPE", "Percentage"],
    ];

    data1.push(
      ["1", "Present Employees", percentage.countforAttendances],
      ["2", "Absent Employees", percentage.countforAbsent],
      ["3", "Week Off", percentage.WeekOFF],
      ["4", "Working Employees", percentage.workingEmp],
      ["5", "Employees", percentage.EmployeeCounts],

      [" ", " ", "  "],

      ["  ", " ", "  "],

      ["  ", "  ", "  "],

      ["  ", " ", " "],

      [
        "Sno",
        EMpROleSelected.value == "2" ? "Zone Name" : null,
        "Name",
        "Punch In",
        "Punch Out",
      ]
    );
    let checkInTimeCount = 0;

    // Iterate through the attendanceData to add the employee details
    attendanceData.forEach((record, index) => {
      const {
        user_id,
        present,
        leave,
        date,
        weekoff,
        working,
        check_in_time,
        check_out_time,
        zone_id,
      } = record;
      const name = user_id ? user_id.first_name : "Unknown";
      // console.log(record.user_id.zone_id , "record");
      const dateString = check_in_time;
      const dateObject = new Date(dateString);
      const hours = dateObject.getHours();
      const minutes = dateObject.getMinutes();
      const seconds = dateObject.getSeconds();
      const amOrPm = hours >= 12 ? "PM" : "AM";
      const twelveHourFormat = hours % 12 || 12;
      if (check_in_time) {
        checkInTimeCount++;
      }

      const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

      const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

      const dateStringCheckout = check_out_time;
      const dateCheckoutObject = new Date(dateStringCheckout);
      const hourscheckout = dateCheckoutObject.getHours();
      const minuteschecko = dateCheckoutObject.getMinutes();
      const secondsCheckO = dateCheckoutObject.getSeconds();
      const amOrPmChOut = hourscheckout >= 12 ? "PM" : "AM";
      const twelveHourFormatOut = hourscheckout % 12 || 12;

      const formattedMinutesOut =
        minuteschecko < 10 ? `0${minuteschecko}` : minuteschecko;

      const formattedTimeOut = `${twelveHourFormatOut}:${formattedMinutesOut} ${amOrPmChOut}`;

      let type = "Unknown";
      const checkoutTime =
        formattedTimeOut && check_out_time ? formattedTimeOut : "--";
      const checkInTime = formattedTime && check_in_time ? formattedTime : "--";
      // console.log(checkInTime, "checkInTime");
      const check_in = check_in_time
        ? check_in_time + " " + check_in_time
        : "--";
      const check_out = check_out_time
        ? check_out_time + "" + check_out_time
        : "--";
      var ZoneName = [];
      var StateName = [];
      var Names = [];
      // if (
      //   record.user_id.zone_id != undefined &&
      //   record.user_id.zone_id != null
      // ) {
      //   record.user_id.zone_id.forEach((item, index) => {
      //     // console.log(item.zone_name, "item.zone_name");
      //     // item.zone_name == Name.ZoneName &&
      //     if (item.zone_name == Name.ZoneName && index == 0) {
      //       ZoneName.push(item.zone_name);
      //       Names.push(name);
      //     }
      //   });
      // }

      if (
        record.user_id.zone_id != undefined &&
        record.user_id.zone_id != null
      ) {
        record.user_id.zone_id.forEach((item, index) => {
          // console.log(
          //   index,
          //   item,
          //   "item.zone_name",
          //   item.zone_name,
          //   Name.ZoneName
          // );
          // item.state_name == Name.StateName &&
          // console.log(multiselect3.label, "multiselect");
          //     if (multiselect3.label == "All") {
          //       if (index == 0) {
          //         ZoneName.push(item.state_name);
          //       }
          //     } else {
          //       if (index == 0) {
          //         ZoneName.push(multiselect3.label);
          //       }
          //     }
          //     if (item.state_name == Name.ZoneName) {
          //       Names.push(user_id.first_name ? user_id.first_name : "Unknown");
          //     }
          //   });
          // }

          if (
            multiselect3[0]?.label != undefined
              ? multiselect3[0]?.label == "All"
              : multiselect3.label == "All"
          ) {
            if (index == 0) {
              ZoneName.push(item.zone_name);
            }
          } else {
            if (index == 0) {
              ZoneName.push(
                multiselect3[0]?.label != undefined
                  ? multiselect3[0]?.label
                  : multiselect3.label
              );
            }
          }
          if (item.zone_name == Name.ZoneName) {
            Names.push(user_id.first_name ? user_id.first_name : "Unknown");
          }
        });
      }

      const dateFile = date ? date : "---";

      data1.push([
        index + 1,
        EMpROleSelected.value == "2" ? ZoneName : null,
        name,
        // Names,
        // dateFile,
        checkInTime,
        checkoutTime,
        // Assuming percentage is calculated and added to the data
      ]);
    });

    data1.push(
      [" ", " ", "  "],
      ["  ", " ", "  "],
      ["  ", "  ", "  "],
      ["  ", " ", " "],
      ["Total-Punched Counter ", checkInTimeCount]
    );
    // Add a summary row
    const ws = XLSX.utils.aoa_to_sheet(data1);

    // Apply left alignment to all cells
    Object.keys(ws).forEach((key) => {
      if (key[0] !== "!") {
        // Exclude special keys such as "!ref"
        ws[key].s = {
          alignment: {
            horizontal: "left",
          },
        };
      }
    });

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    // Generate Excel file and trigger a download
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const dataBlob = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });
    saveAs(dataBlob, `${range[0] + "-" + range[1]}Attendance.xlsx`);
  };

  const openMe = ()=>{
    const rsAnimFade = document.querySelector('.rs-anim-fade');
    if (rsAnimFade) {
      rsAnimFade.style.setProperty('left', '1120.344px', 'important');
      rsAnimFade.style.setProperty('top', '186.109px', 'important');   
    }
   }
  
   const CloseDateRange = ()=>{
    const rsAnimFade = document.querySelector('.rs-anim-fade');
    if (rsAnimFade) {
      rsAnimFade.style.setProperty('display', 'none', 'important');
      // rsAnimFade.style.setProperty('top', '184.109px', 'important');   
    }
   }


  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            // className="InnerUsers col-md-6"
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            {RoleBased != undefined ? (
              <h2 class="user-name mb-0 WelcomeContent">{`Welcome ${capitalizeFirstLetter(
                RoleBased
              )}! `}</h2>
            ) : null}
            {/* <ul class="breadcrumb">
              <li class="breadcrumb-item">Attendance Overview</li>
            </ul> */}
          </div>
        </div>

        <div
          className=" row Filters "
          style={{
            marginRight: "0px",
            marginLeft: "0px",
            padding: "0px 30px",
            zIndex: "89",
            marginTop:"14px "

          }}
        >
          <div
            className="col-sm-2"
            style={{ marginTop: "-19px", zIndex: "99" }}
          >
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              State 
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => {
                setMuliselect(e);
              }}
              onChange={(e) => {
                console.log("onchange in attendance");
                handleSelectChange(e);
              }}
              options={nameList}
              onInputChange={handleInputChange}
              onremoved={(e) => {
                setMuliselect(e);
                console.log(e, "jjk9090");
              }}
              value={multiselect}
              labelledBy="Select"
              // placeholder={"Search"}
            />
          </div>

          <div className="col-sm-2" style={{ marginTop: "-19px" }}>
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              Region 
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMuliselect1(e)}
              onChange={(e) => {
                handelRegionSlect(e);
              }}
              options={nameList2}
              labelledBy="Select"
              isClearable={true}
              onremoved={(e) => {
                setMuliselect1(e);
              }}
              value={multiselect1}
              onInputChange={handleInputRegion}
              // placeholder={
              //   datas.state == ""
              //     ? "without selected state you can't select Region"
              //     : "search"
              // }
            />
          </div>

          <div className="col-sm-2" style={{ marginTop: "-19px" }}>
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              Zone 
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMuliselect3(e)}
              onChange={(e) => {
                handleZone(e);
              }}
              value={multiselect3}
              options={nameList5}
              isClearable={true}
              onremoved={(e) => {
                setMuliselect3(e);
                console.log(e, "jjk9090");
              }}
              labelledBy="Select"
              onInputChange={handleInputZone}
            />
          </div>
          {!filterForWhite.white_collar ? (
            <div
              className="col-sm-2"
              style={{ zIndex: "20", marginTop: "-19px" }}
            >
              <label
                for="validationCustom01"
                class="form-label"
                style={{ fontSize: "19px" }}
              >
                Client 
              </label>
              <Select
                className="Selects"
                styles={{ position: "relative", top: "60px" }}
                onSelect={(e) => {
                  SetSelectValue(e);
                  dispatch(SetTheDashboardClientList(e));
                }}
                onChange={(e) => {
                  HandleClientBranches(e);
                }}
                options={nameList4}
                labelledBy="Select"
                onInputChange={HandleInputBranch}
                isClearable={true}
                value={state.DashboardCall.DashboardCLientList}
              />
            </div>
          ) : null}
          <div
            class=" field-div col-sm-2"
            style={{ zIndex: "20", marginTop: "-19px" }}
          >
            <label
              for="validationCustom02"
              class="form-label FilterLabel"
              // style={{ fontSize: "15px" }}
            >
              Employee Designation
            </label>

            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              onChange={(e) => {
                HandleEMprole(e);
              }}
              value={EMpROleSelected}
              options={EmpRoles}
              placeholder="search"
            />
          </div>

          <div
            className="col-sm-2 SelectedDate"
            style={{marginTop:"-21px"}}
          >
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px", width: "100%" }}
            >
              Select Date<span style={{ color: "red" }}>*</span>


            </label>

            <div className="datepicker_dash">
              <DateRangePicker
                defaultValue={
                  state.EmployeeVerificationsNeed.AttendanceFROMDATE == "" ?
                  [
                  // new Date(new Date().setDate(today.getDate() - 30)),
                  // new Date(),

                  // new Date(),
                ]
                :
                [
                  // new Date(new Date().setDate(today.getDate() - 30)),
                  new Date(state.EmployeeVerificationsNeed.AttendanceFROMDATE),

                  new Date(state.EmployeeVerificationsNeed.AttendanceTODATE),
                ]


              }
              onOpen={() => {
                openMe()
              }}
           onClose={() => {
              CloseDateRange()
                 }}
                disabledDate={(date) => isAfter(date, new Date())}
                editable={false}
                appearance="default"
                placement="bottomEnd"
                size="lg"
                ranges={predefinedBottomRanges}
                placeholder="From - To"
                // style={{ width: 270, padding: 10 }}
                onClean={(e) => cleaningrange(e)}
                onChange={(e) => {
                  // if (e != null) {
                  //   setrange([]);
                  //   e.forEach((newValue) => {
                  //     var tzoffset = new Date().getTimezoneOffset() * 60000; //offset in milliseconds
                  //     var localISOTime = new Date(newValue - tzoffset)
                  //       .toISOString()
                  //       .slice(0, -1);
                  //     handlechangedate(localISOTime);
                  //   });
                  // }

                  if (e != null && e.length === 2) {
                    const [startDate, endDate] = e;
                    const diffDays = differenceInDays(endDate, startDate);
                    if (diffDays === 30) {
                      // Since we are using inclusive range, difference should be 30 for 31 days
                      setrange([]);
                      e.forEach((newValue) => {
                        const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
                        const localISOTime = new Date(newValue - tzoffset)
                          .toISOString()
                          .slice(0, -1);
                        handlechangedate(localISOTime);
                      });
                    } else if (diffDays < 30) {
                      setrange([]);
                      e.forEach((newValue) => {
                        const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
                        const localISOTime = new Date(newValue - tzoffset)
                          .toISOString()
                          .slice(0, -1);
                        handlechangedate(localISOTime);
                      });
                    } else {
                      toast.error("Please select a range of exactly 31 days.", {
                        position: toast.POSITION.TOP_RIGHT,
                      });
                    }
                  }
                }}
              />
            </div>
          </div>

          {/* {state.EmployeeDashBoardAttedances.AttedanceDatas.employee_count !=
          0 ? (
            <>
              {EMpROleSelected.value == "1" || EMpROleSelected.value == "2" ? (
                <div className="col-sm-2" style={{ marginTop: "14px" }}>
                  <button
                    align="center"
                    type="button"
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      background: "transparent",
                    }}
                    onClick={(e) => {
                      if (range[0] == range[1]) {
                        if (EMpROleSelected.value == "1") {
                          HandleClick(e, "0");
                        } else if (EMpROleSelected.value == "2") {
                          HandleClickSecond(e, "0");
                        }
                      } else {
                        toast.error(
                          ` ${"The excelsheet can only be downloaded for a single date."} `,
                          {
                            position: toast.POSITION.TOP_RIGHT,
                          }
                        );
                      }
                    }}
                  >
                    <a class="dnbtn"></a>
                  </button>
                </div>
              ) : null}
            </>
          ) : null} */}

        </div>

        <div className="row DashRows">
          <div className="col-12 mt-5">
            <h3 className="DashboardCardHeader">Attendance Details</h3>
          </div>

          <div className="col-12">
            <div
              className="row DashRows DashboardOverview"
            >
              <div
                // className="col-xl-4 col-sm-6 col-12"
                className="col-sm-2"
                style={{
                  display: "flex",
                  alignItems: "center",
                  // border: "3px solid red",
                  flexDirection: "column",
                }}
              >
                <div
                  className="card Dashboard01"

                  onClick={(e) => {
                    if (range.length > 0) {
                      dispatch(setTheAttendanceDhasboardStatus("working"));
                      dispatch(setTheAttendanceDateLIST(range[0]));
                      dispatch(setAttendacenDASHTodate(range[1]));
                      dispatch(seTheWhiteCollar_objects(EMpROleSelected));
                      // dispatch(settheStateObjects([multiselect]));
                      // dispatch(setTheregionsObjects([multiselect1]));
                      // dispatch(setTheZoneObjects([multiselect3]));
                      if (
                        multiselect != undefined &&
                        multiselect1 != undefined &&
                        multiselect3 != undefined
                      ) {
                        dispatch(
                          settheStateObjects(
                            multiselect[0] ? multiselect[0] : multiselect
                          )
                        );
                        dispatch(
                          setTheregionsObjects(
                            multiselect1[0] ? multiselect1[0] : multiselect1
                          )
                        );

                        dispatch(
                          setTheZoneObjects(
                            multiselect3[0] ? multiselect3[0] : multiselect3
                          )
                        );
                      }
                      if (
                        multiselect1 == undefined ||
                        multiselect1 == undefined ||
                        multiselect3 == undefined
                      ) {
                        if (multiselect == undefined) {
                          dispatch(
                            settheStateObjects({ value: "", label: "ALL" })
                          );
                          dispatch(
                            setTheregionsObjects({ value: "", label: "ALL" })
                          );
                          dispatch(
                            setTheZoneObjects({ value: "", label: "ALL" })
                          );
                        }
                        if (multiselect1 == undefined) {
                          dispatch(
                            setTheregionsObjects({ value: "", label: "ALL" })
                          );
                          dispatch(
                            setTheZoneObjects({ value: "", label: "ALL" })
                          );
                        }
                        if (multiselect3 == undefined) {
                          dispatch(
                            setTheZoneObjects({ value: "", label: "ALL" })
                          );
                        }
                      }

                      dispatch(seTheWhiteCollor(filterForWhite.white_collar));
                      Navigate("/attendancereport");
                    } else if (range.length == 0) {
                      toast.error(` ${"Please Select the Date"} `, {
                        position: toast.POSITION.TOP_RIGHT,
                      });
                    }
                  }}
                >
                  <div
                    className="card-Body DashboardCardBody"
                   
                  >

                      <div
                        className="DashICON iconsEmpVer"

                      
                      >
                        <img
                          src={EmployeeIcons}
                          style={{ width: "100%", height: "100%" }}
                        />
                      </div>

                      <div
                        className="Counts"
                      >
                        <span

                          className="DashboardCardHeader OnboardDash"
                        >
                          {range.length === 0 ? (
                            PresentEmp.workingEmp !== undefined ? (
                              <>{`${PresentEmp.workingEmp}`}</>
                            ) : null
                          ) : range.length > 0 && range[0] !== range[1] ? (
                            percentage.workingEmp !== undefined ? (
                              <>{`${percentage.workingEmp}%`}</>
                            ) : null
                          ) : range.length > 0 &&
                            range[0] === range[1] &&
                            PresentEmp.workingEmp !== undefined ? (
                            <>{`${PresentEmp.workingEmp}`}</>
                          ) : (
                            0
                          )}

                        </span>

                        <span
                          className="DashboardCardHeader DashboardHeaderStatus"
                        >
                          Working Employees
                        </span>
                      </div>
                    {/* </div> */}
                  </div>
                </div>
              </div>

              <div
                // className="col-xl-4 col-sm-6 col-12"
                className="col-sm-2"
                style={{
                  display: "flex",
                  alignItems: "center",
                  // border: "3px solid red",
                  flexDirection: "column",
                }}
              >
                <div
                  className="card Dashboard01"
                  onClick={(e) => {
                    if (range.length > 0) {
                      dispatch(setTheAttendanceDhasboardStatus("all_employee"));
                      dispatch(setTheAttendanceDateLIST(range[0]));
                      dispatch(setAttendacenDASHTodate(range[1]));
                      dispatch(seTheWhiteCollar_objects(EMpROleSelected));
                      // dispatch(settheStateObjects([multiselect]));
                      // dispatch(setTheregionsObjects([multiselect1]));
                      // dispatch(setTheZoneObjects([multiselect3]));
                      if (
                        multiselect != undefined &&
                        multiselect1 != undefined &&
                        multiselect3 != undefined
                      ) {
                        dispatch(
                          settheStateObjects(
                            multiselect[0] ? multiselect[0] : multiselect
                          )
                        );
                        dispatch(
                          setTheregionsObjects(
                            multiselect1[0] ? multiselect1[0] : multiselect1
                          )
                        );

                        dispatch(
                          setTheZoneObjects(
                            multiselect3[0] ? multiselect3[0] : multiselect3
                          )
                        );
                      }
                      if (
                        multiselect1 == undefined ||
                        multiselect1 == undefined ||
                        multiselect3 == undefined
                      ) {
                        if (multiselect == undefined) {
                          dispatch(
                            settheStateObjects({ value: "", label: "ALL" })
                          );
                          dispatch(
                            setTheregionsObjects({ value: "", label: "ALL" })
                          );
                          dispatch(
                            setTheZoneObjects({ value: "", label: "ALL" })
                          );
                        }
                        if (multiselect1 == undefined) {
                          dispatch(
                            setTheregionsObjects({ value: "", label: "ALL" })
                          );
                          dispatch(
                            setTheZoneObjects({ value: "", label: "ALL" })
                          );
                        }
                        if (multiselect3 == undefined) {
                          dispatch(
                            setTheZoneObjects({ value: "", label: "ALL" })
                          );
                        }
                      }

                      dispatch(seTheWhiteCollor(filterForWhite.white_collar));

                      // Navigate("/attendancereport");
                      Navigate("/EmployeelistView");
                    } else if (range.length == 0) {
                      toast.error(` ${"Please Select the Date"} `, {
                        position: toast.POSITION.TOP_RIGHT,
                      });
                    }
                  }}
                >
                  <div
                    className="card-Body DashboardCardBody"
                  >

                      <div
                        className="DashICON iconsEmpVer"
                      >
                        <img
                          src={EmployeeIcons}
                          style={{ width: "100%", height: "100%" }}
                        />
                      </div>

                      <div
                        className="Counts"
                        style={{
                          fontSize: "30px",
                          display: "flex",
                          flexDirection: "column",
                          marginLeft:"84px",
                          position:"absolute"

                        }}  
                      >
                        <span

                          className="DashboardCardHeader OnboardDash"
                        >
                          {/* {attendanceTotalWork} */}
                          {PresentEmp.EmployeeCounts}
                          {/* {percentage.EmployeeCounts != undefined ? (
                            <>{percentage.EmployeeCounts}</>
                          ) : null} */}
                        </span>

                        <span
                          className="DashboardCardHeader"
                        >
                          Employees
                        </span>
                      </div>
                    </div>
                </div>
              </div>

              <div
                // className="col-xl-4 col-sm-6 col-12"
                className="col-sm-2"
                style={{
                  display: "flex",
                  alignItems: "center",
                  // border: "3px solid red",
                  flexDirection: "column",
                }}
              >
                <div
                  className="card Dashboard01"

                  onClick={(e) => {
                    if (range.length > 0) {
                      dispatch(setTheAttendanceDhasboardStatus("present"));
                      dispatch(setTheAttendanceDateLIST(range[0]));
                      dispatch(setAttendacenDASHTodate(range[1]));
                      dispatch(seTheWhiteCollar_objects(EMpROleSelected));
                      // dispatch(settheStateObjects([multiselect]));
                      // dispatch(setTheregionsObjects([multiselect1]));
                      // dispatch(setTheZoneObjects([multiselect3]));
                      if (
                        multiselect != undefined &&
                        multiselect1 != undefined &&
                        multiselect3 != undefined
                      ) {
                        dispatch(
                          settheStateObjects(
                            multiselect[0] ? multiselect[0] : multiselect
                          )
                        );
                        dispatch(
                          setTheregionsObjects(
                            multiselect1[0] ? multiselect1[0] : multiselect1
                          )
                        );

                        dispatch(
                          setTheZoneObjects(
                            multiselect3[0] ? multiselect3[0] : multiselect3
                          )
                        );
                      }
                      if (
                        multiselect1 == undefined ||
                        multiselect1 == undefined ||
                        multiselect3 == undefined
                      ) {
                        if (multiselect == undefined) {
                          dispatch(
                            settheStateObjects({ value: "", label: "ALL" })
                          );
                          dispatch(
                            setTheregionsObjects({ value: "", label: "ALL" })
                          );
                          dispatch(
                            setTheZoneObjects({ value: "", label: "ALL" })
                          );
                        }
                        if (multiselect1 == undefined) {
                          dispatch(
                            setTheregionsObjects({ value: "", label: "ALL" })
                          );
                          dispatch(
                            setTheZoneObjects({ value: "", label: "ALL" })
                          );
                        }
                        if (multiselect3 == undefined) {
                          dispatch(
                            setTheZoneObjects({ value: "", label: "ALL" })
                          );
                        }
                      }

                      dispatch(seTheWhiteCollor(filterForWhite.white_collar));
                      Navigate("/attendancereport");
                    } else if (range.length == 0) {
                      toast.error(` ${"Please Select the Date"} `, {
                        position: toast.POSITION.TOP_RIGHT,
                      });
                    }
                  }}
                >
                  <div
                    className="card-Body DashboardCardBody"
                  >
        
                      <div
                        className="DashICON iconsEmpVer"
                      >
                        <img
                          src={ApproveIcon}
                          style={{ width: "100%", height: "100%" }}
                        />
                      </div>

                      <div
                        className="Counts"

                        style={{
                          fontSize: "30px",
                          display: "flex",
                          flexDirection: "column",
                          marginLeft:"84px",
                          position:"absolute"

                        }}
                      >
                        <span
                         className="OnboardDash"

                        >
                          {range.length === 0 ? (
                            PresentEmp.PresentEMp !== undefined ? (
                              <>{`${PresentEmp.PresentEMp}`}</>
                            ) : null
                          ) : range.length > 0 && range[0] !== range[1] ? (
                            percentage.countforAttendances !== undefined ? (
                              <>{`${percentage.countforAttendances}%`}</>
                            ) : null
                          ) : range.length > 0 &&
                            range[0] === range[1] &&
                            PresentEmp.PresentEMp !== undefined ? (
                            <>{`${PresentEmp.PresentEMp}`}</>
                          ) : (
                            0
                          )}
                        </span>

                        <span
                          className="DashboardCardHeader DashboardHeaderStatus"
                        >
                          Present
                        </span>
                      </div>
                    </div>
                </div>
              </div>

              <div
                // className="col-xl-4 col-sm-6 col-12"
                className="col-sm-2 "
                style={{
                  display: "flex",
                  alignItems: "center",
                  // border: "3px solid red",
                  flexDirection: "column",
                }}
              >
                <div
                  className="card Dashboard01"

                  onClick={(e) => {
                    if (range.length > 0) {
                      dispatch(setTheAttendanceDhasboardStatus("leave"));
                      dispatch(setTheAttendanceDateLIST(range[0]));
                      dispatch(setAttendacenDASHTodate(range[1]));
                      dispatch(seTheWhiteCollar_objects(EMpROleSelected));
                      // dispatch(settheStateObjects([multiselect]));
                      // dispatch(setTheregionsObjects([multiselect1]));
                      // dispatch(setTheZoneObjects([multiselect3]));
                      if (
                        multiselect != undefined &&
                        multiselect1 != undefined &&
                        multiselect3 != undefined
                      ) {
                        dispatch(
                          settheStateObjects(
                            multiselect[0] ? multiselect[0] : multiselect
                          )
                        );
                        dispatch(
                          setTheregionsObjects(
                            multiselect1[0] ? multiselect1[0] : multiselect1
                          )
                        );

                        dispatch(
                          setTheZoneObjects(
                            multiselect3[0] ? multiselect3[0] : multiselect3
                          )
                        );
                      }
                      if (
                        multiselect1 == undefined ||
                        multiselect1 == undefined ||
                        multiselect3 == undefined
                      ) {
                        if (multiselect == undefined) {
                          dispatch(
                            settheStateObjects({ value: "", label: "ALL" })
                          );
                          dispatch(
                            setTheregionsObjects({ value: "", label: "ALL" })
                          );
                          dispatch(
                            setTheZoneObjects({ value: "", label: "ALL" })
                          );
                        }
                        if (multiselect1 == undefined) {
                          dispatch(
                            setTheregionsObjects({ value: "", label: "ALL" })
                          );
                          dispatch(
                            setTheZoneObjects({ value: "", label: "ALL" })
                          );
                        }
                        if (multiselect3 == undefined) {
                          dispatch(
                            setTheZoneObjects({ value: "", label: "ALL" })
                          );
                        }
                      }

                      dispatch(seTheWhiteCollor(filterForWhite.white_collar));
                      Navigate("/attendancereport");
                    } else if (range.length == 0) {
                      toast.error(` ${"Please Select the Date"} `, {
                        position: toast.POSITION.TOP_RIGHT,
                      });
                    }
                  }}
                >
                  <div
                    className="card-Body DashboardCardBody"
                
                  >
                      <div
                        className="DashICON iconsEmpVer"
                        >
                        <img
                          src={DeclineIcon}
                          style={{ width: "100%", height: "100%" }}
                        />
                      </div>

                      <div
                        className="Counts"

                        style={{
                          fontSize: "30px",
                          display: "flex",
                          flexDirection: "column",
                          marginLeft:"84px",
                          position:"absolute"

                        }}
                      >
                        <span
className="OnboardDash"
                        >
                          {range.length === 0 ? (
                            PresentEmp.AbsentEmp !== undefined ? (
                              <>{`${PresentEmp.AbsentEmp}`}</>
                            ) : null
                          ) : range.length > 0 && range[0] !== range[1] ? (
                            percentage.countforAbsent !== undefined ? (
                              <>{`${percentage.countforAbsent}%`}</>
                            ) : null
                          ) : range.length > 0 &&
                            range[0] === range[1] &&
                            PresentEmp.AbsentEmp !== undefined ? (
                            <>{`${PresentEmp.AbsentEmp}`}</>
                          ) : (
                            0
                          )}
                        </span>

                        <span
                          className="DashboardCardHeader"
                        >
                          Absent{" "}
                        </span>
                      </div>
                  </div>
                </div>
              </div>

              <div
                // className="col-xl-4 col-sm-6 col-12"
                className="col-sm-2"
                style={{
                  display: "flex",
                  alignItems: "center",
                  // border: "3px solid red",
                  flexDirection: "column",
                }}
              >
                <div
                  className="card Dashboard01"

                  onClick={(e) => {
                    if (range.length > 0) {
                      dispatch(setTheAttendanceDhasboardStatus("weekoff"));
                      dispatch(setTheAttendanceDateLIST(range[0]));
                      dispatch(setAttendacenDASHTodate(range[1]));
                      dispatch(seTheWhiteCollar_objects(EMpROleSelected));

                      // dispatch(settheStateObjects([multiselect]));
                      // dispatch(setTheregionsObjects([multiselect1]));
                      // dispatch(setTheZoneObjects([multiselect3]));

                      if (
                        multiselect != undefined &&
                        multiselect1 != undefined &&
                        multiselect3 != undefined
                      ) {
                        dispatch(
                          settheStateObjects(
                            multiselect[0] ? multiselect[0] : multiselect
                          )
                        );
                        dispatch(
                          setTheregionsObjects(
                            multiselect1[0] ? multiselect1[0] : multiselect1
                          )
                        );

                        dispatch(
                          setTheZoneObjects(
                            multiselect3[0] ? multiselect3[0] : multiselect3
                          )
                        );
                      }
                      if (
                        multiselect1 == undefined ||
                        multiselect1 == undefined ||
                        multiselect3 == undefined
                      ) {
                        if (multiselect == undefined) {
                          dispatch(
                            settheStateObjects({ value: "", label: "All" })
                          );
                          dispatch(
                            setTheregionsObjects({ value: "", label: "All" })
                          );
                          dispatch(
                            setTheZoneObjects({ value: "", label: "All" })
                          );
                        }
                        if (multiselect1 == undefined) {
                          dispatch(
                            setTheregionsObjects({ value: "", label: "All" })
                          );
                          dispatch(
                            setTheZoneObjects({ value: "", label: "All" })
                          );
                        }
                        if (multiselect3 == undefined) {
                          dispatch(
                            setTheZoneObjects({ value: "", label: "All" })
                          );
                        }
                      }

                      dispatch(seTheWhiteCollor(filterForWhite.white_collar));
                      Navigate("/attendancereport");
                    } else if (range.length == 0) {
                      toast.error(` ${"Please Select the Date"} `, {
                        position: toast.POSITION.TOP_RIGHT,
                      });
                    }
                  }}
                >
                  <div
                    className="card-Body DashboardCardBody"
                  >
  
                      <div
                        className="DashICON iconsEmpVer"
                      >
                        <img
                          src={WeekOFF}
                          style={{ width: "100%", height: "100%" }}
                        />
                      </div>

                      <div
                        className="Counts"

                        style={{
                          fontSize: "30px",
                          display: "flex",
                          flexDirection: "column",
                          marginLeft:"84px",
                          position:"absolute"

                        }}
                      >
                        <span
                         className="OnboardDash"
                        >
                          {range.length === 0 ? (
                            PresentEmp.WeekOff !== undefined ? (
                              <>{`${PresentEmp.WeekOff}`}</>
                            ) : null
                          ) : range.length > 0 && range[0] !== range[1] ? (
                            percentage.WeekOFF !== undefined ? (
                              <>{`${percentage.WeekOFF}%`}</>
                            ) : null
                          ) : range.length > 0 &&
                            range[0] === range[1] &&
                            PresentEmp.WeekOff !== undefined ? (
                            <>{`${PresentEmp.WeekOff}`}</>
                          ) : (
                            0
                          )}
                        </span>
                        <span
                          className="DashboardCardHeader DashboardHeaderStatus"
                        >
                          Week Off
                        </span>
                      </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="row DashRows "
          style={{
            marginTop: "60px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div className="col-4">
            {/* <PieChart
              series={[
                {
                  arcLabel: (item) => `${item.value}%`,
                  arcLabelMinAngle: 45,
                  data,
                  highlightScope: { faded: 'global', highlighted: 'item' },
                  faded: { innerRadius: 30, additionalRadius: -30, color: 'gray' },
            
                },
              ]}
              sx={{
                [`& .${pieArcLabelClasses.root}`]: {
                  fill: "white",
                  fontWeight: "bold",
                  fontSize: "10px",
                },
              }}
              {...size}
              style={{ boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px" }}
              className="MaterialUipieChart"
            /> */}

            {/* {!AttendanceZeor ? ( */}

            {
              // state.EmployeeDashBoardAttedances.AttedanceDatas == null ||
              (
                state.EmployeeDashBoardAttedances.AttedanceDatas
                .present_employee_percentage != 0 ||
                state.EmployeeDashBoardAttedances.AttedanceDatas
                  .absent_employee_percentage != 0 
                  ||
                state.EmployeeDashBoardAttedances.AttedanceDatas
                  .working_employee_percentage != 0
                
                ) 
                  
                  &&
              range.length > 0 &&
              !range.includes("NaN-aN-aN") ? (
                <div class="card">
                  <Chart
                    chartType="PieChart"
                    data={Attendancedata}
                    options={options_attendances}
                    width={"400px"}
                    height={"290px"}
                    className="DashboardCardHeader"
                  />
                </div>
              ) : (
                <div className="col-4">
                  <div
                    class="card"
                    style={{
                      display: "flex",
                      alignItems: "left",
                      justifyContent: "left",
                      height: "299px",
                      width: "425px",
                    }}
                  >
                    <div className="card-body">
                      <h3
                        style={{ fontWeight: "900" }}
                        className="DashboardCardHeader"
                      >
                        Employees Attendance
                      </h3>
                      <p className="DashboardCardHeader Nodatas">
                        {" "}
                        No data available
                      </p>{" "}
                    </div>
                  </div>
                </div>
              )
            }

            {/* ) : null} */}
          </div>

          {/* <div className="col-6" style={{ marginTop: "-29px" }}>
            <ApexChart />
          </div> */}
        </div>
      </div>
    </>
  );
};

export default AttendanceDash;
